module.exports = __webpack_public_path__ + "img/no_ring.96684dd7.png";